import {
  PtdDispatchDetails,
  PreDispatchDetails,
  Proforma,
  PtdDispatchService,
  ClientDetails,
} from 'coadapi';

export default class Utils {

  static async createDispatch(details: PreDispatchDetails, dispatchService: PtdDispatchService) {
    return await dispatchService.createDispatch(details).toPromise();
    // .subscribe({
    //   next: (result: any) => {
    //     console.log(result);
    //   },
    //   complete: () => {
    //     console.log('update complete');
    //     return true;
    //   },
    // });
  }

  static updateDispatch(details: PtdDispatchDetails, update: PreDispatchDetails, dispatchService: PtdDispatchService) {
    const detailsAny = details as any;
    const resolvedClientId = details?.modelClient?.clientId ?? update?.varClient ?? 0;
    update.varClient = resolvedClientId;
    update.dispatch = details.dispatchId;
    if (update.eta === undefined) {
      update.eta = details.dispatchEta ?? detailsAny.eta;
    }
    if (update.ets === undefined) {
      update.ets = details.dispatchEts ?? detailsAny.dispatchEtd ?? detailsAny.etd;
    }
    if (update.externalEts === undefined) {
      update.externalEts = detailsAny.externalEts
    }
    if (update.varClient > 0) {
      dispatchService.updateDispatch(update).subscribe({
        next: (result: any) => {
          console.log(result);
        },
        complete: () => {
          console.log('update complete');
          return true;
        },
      });
    }
  }

  static updateIWD(details: PtdDispatchDetails, update: PreDispatchDetails, dispatchService: PtdDispatchService, originDispatch: PtdDispatchDetails) {
    const resolvedClientId = details?.modelClient?.clientId ?? update?.varClient ?? 0;
    update.varClient = resolvedClientId;
    update.dispatch = details.dispatchId;
    const iwdWarehouseId = update?.warehouse ?? details?.dispatchWarehouse?.warehouseId;
    const originDispatchId = originDispatch?.dispatchId;
    if (typeof originDispatchId !== 'number') {
      return;
    }
    if (typeof iwdWarehouseId !== 'number') {
      return;
    }
    const safeIwdWarehouseId: number = iwdWarehouseId;
    dispatchService.updateIWDDispatch(originDispatchId, safeIwdWarehouseId, update).subscribe({
      next: (result: any) => {
        console.log(result);
      },
      complete: () => {
        console.log('update complete');
        return true;
      },
    });
  }

  static mapDetailsToUpdate(details: PtdDispatchDetails, update: PreDispatchDetails, client: ClientDetails): PreDispatchDetails {
    const detailsAny = details as any;
    update.varClient = client?.modelClient?.clientId ?? 0;
    update.closedIwd = details.closedToIwd;
    update.deliveryAddress = details.dispatchDeliveryAddress?.addressId;
    update.consigneeAddress = details.dispatchConsigneeAddress?.addressId;
    update.dispatch = details.dispatchId;
    update.eta = details.dispatchEta ?? detailsAny.eta;
    update.ets = details.dispatchEts ?? detailsAny.dispatchEtd ?? detailsAny.etd;
    update.externalEts = detailsAny.externalEts
      ?? detailsAny.externalETS
      ?? detailsAny.dispatchExternalETS
      ?? detailsAny.dispatchExternalEts
      ?? detailsAny.dispatchExternalEtd
      ?? detailsAny.dispatchExternalETD
      ?? detailsAny.externalEtd
      ?? detailsAny.externalETD;
    update.incotermLocation = details.incotermLocation
      ?? detailsAny.incotermLocation
      ?? detailsAny.incotermlocation
      ?? '';
    update.incoterm = details.incoterm?.incotermId;
    update.method = details.dispatchFreightMethod?.methodId;
    update.warehouse = details.dispatchWarehouse?.warehouseId;
    update.clientAgent = client?.modelClient?.preferredAgent?.agentId;
    update.clientAgentContact = client?.modelClient?.preferredAgentContact?.contactId;
    update.clientContact = client?.modelClient?.preferredAgentContact?.contactId;
    update.descriptive = details.descriptive?.descriptiveId; 
    update.shipmentCategory = details.dispatchNoLetter?.commodityID;
    return update;
  }
}


